/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { get as lodashGet } from "lodash";

export const set = (property: string) => (state: any, payload: any) =>
  (state[property] = payload);
export const get = (propertyPath: string) => (state: any) =>
  lodashGet(state, propertyPath);
export const toggle = (property: string) => (state: any) =>
  (state[property] = !state[property]);
